import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-counter',
	templateUrl: './counter.component.html',
	styleUrls: ['./counter.component.scss'],
})

/**
 * Counter Component
 */
export class CounterComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
